import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, TwitterIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };
  const partners = [{
    name: 'Kreative Studio',
    id: '1'
  }, {
    name: 'VisionGraph',
    id: '2'
  }, {
    name: 'ArtZone',
    id: '3'
  }, {
    name: 'MediaWorks',
    id: '4'
  }];
  return <footer className="bg-gray-900 text-white" data-id="element-90">
      {/* Partners Section */}
      <div className="bg-gray-800 py-8" data-id="element-91">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
          <h3 className="text-center text-lg font-semibold mb-6" data-id="element-93">
            Our Featured Partners
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-6" data-id="element-94">
            {partners.map(partner => <div key={partner.id} className="bg-white text-gray-800 px-6 py-3 rounded-lg font-medium text-sm" data-id="element-95">
                {partner.name}
              </div>)}
            <div className="flex items-center space-x-4" data-id="element-96">
              <a href="#" className="text-blue-400 hover:text-blue-300 transition-colors" aria-label="Twitter" data-id="element-97">
                <TwitterIcon className="w-6 h-6" data-id="element-98" />
              </a>
              <a href="#" className="text-blue-400 hover:text-blue-300 transition-colors" aria-label="Instagram" data-id="element-99">
                <InstagramIcon className="w-6 h-6" data-id="element-100" />
              </a>
              <a href="#" className="text-blue-400 hover:text-blue-300 transition-colors" aria-label="Facebook" data-id="element-101">
                <FacebookIcon className="w-6 h-6" data-id="element-102" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-103">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-104">
          {/* Quick Links */}
          <div data-id="element-105">
            <h4 className="text-lg font-semibold mb-4" data-id="element-106">Quick Links</h4>
            <ul className="space-y-2" data-id="element-107">
              <li data-id="element-108">
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-id="element-109">
                  Home
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/goods" className="text-gray-400 hover:text-white transition-colors" data-id="element-111">
                  Goods
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors" data-id="element-113">
                  Services
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/events" className="text-gray-400 hover:text-white transition-colors" data-id="element-115">
                  Events
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/news" className="text-gray-400 hover:text-white transition-colors" data-id="element-117">
                  News
                </Link>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div data-id="element-118">
            <h4 className="text-lg font-semibold mb-4" data-id="element-119">About Us</h4>
            <ul className="space-y-2" data-id="element-120">
              <li data-id="element-121">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-122">
                  About Us
                </Link>
              </li>
              <li data-id="element-123">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-124">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-126">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div data-id="element-127">
            <h4 className="text-lg font-semibold mb-4" data-id="element-128">Contact Us</h4>
            <ul className="space-y-3" data-id="element-129">
              <li className="flex items-center space-x-2 text-gray-400" data-id="element-130">
                <MailIcon className="w-4 h-4" data-id="element-131" />
                <span data-id="element-132">info@zingacreatives.com</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400" data-id="element-133">
                <PhoneIcon className="w-4 h-4" data-id="element-134" />
                <span data-id="element-135">+254 700 123 456</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-136">
            <h4 className="text-lg font-semibold mb-4" data-id="element-137">
              Subscribe to our Newsletter
            </h4>
            {subscribed ? <p className="text-green-400" data-id="element-138">Thank you for subscribing!</p> : <form onSubmit={handleSubscribe} className="flex" data-id="element-139">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" className="flex-1 px-4 py-2 rounded-l-md text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500" required data-id="element-140" />
                <button type="submit" className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-r-md text-sm font-medium transition-colors" data-id="element-141">
                  Subscribe
                </button>
              </form>}
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm" data-id="element-142">
          <p data-id="element-143">
            &copy; {new Date().getFullYear()} Zinga Creatives. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}